import React from 'react'
import styles from "./loader.module.css";
const loader = () => {
  return (
    <div className={styles.loaderwrapper}>
      <div className={styles.loader}></div>
        <div/>
    </div>
  )
}

export default loader